import { useState } from "react";
import forms from "@config/download-forms.json";
import { createDownloadLead } from "../lib/api.js";
import SectionTitle from "../components/SectionTitle.jsx";

export default function Downloads({ t }) {
  const [selected, setSelected] = useState(forms[0]);
  const [form, setForm] = useState({ name: "", mobile: "", email: "" });
  const [download, setDownload] = useState(null);
  const [status, setStatus] = useState("");

  function update(event) {
    setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  }

  async function submit(event) {
    event.preventDefault();
    setStatus("Generating download number...");
    try {
      const response = await createDownloadLead({ ...form, formId: selected.id, formName: selected.name });
      setDownload(response);
      setStatus("");
    } catch (error) {
      setStatus(error.response?.data?.message || "Unable to generate download.");
    }
  }

  return (
    <section className="section-shell py-14">
      <SectionTitle title="Download Forms" text="Lead details are captured before the download number is generated." />
      <div className="grid gap-6 lg:grid-cols-[1fr_0.85fr]">
        <div className="grid gap-4 md:grid-cols-2">
          {forms.map((item) => (
            <button
              key={item.id}
              className={`focus-ring premium-card p-5 text-left transition ${selected.id === item.id ? "ring-2 ring-royal" : ""}`}
              onClick={() => {
                setSelected(item);
                setDownload(null);
              }}
            >
              <span className="text-sm font-black uppercase tracking-[0.18em] text-orange">Form</span>
              <h2 className="mt-2 text-xl font-black text-royal">{item.name}</h2>
              <p className="mt-2 text-sm text-muted">{item.fileName}</p>
            </button>
          ))}
        </div>
        <form className="premium-card grid gap-4 p-5" onSubmit={submit}>
          <h2 className="text-2xl font-black text-royal">{selected.name}</h2>
          <input className="focus-ring rounded-sur border border-[var(--line)] px-4 py-3" name="name" value={form.name} onChange={update} placeholder={t.forms.name} required />
          <input className="focus-ring rounded-sur border border-[var(--line)] px-4 py-3" name="mobile" value={form.mobile} onChange={update} placeholder={t.forms.mobile} required />
          <input className="focus-ring rounded-sur border border-[var(--line)] px-4 py-3" name="email" type="email" value={form.email} onChange={update} placeholder={t.forms.email} required />
          <button className="focus-ring rounded-sur bg-orange px-5 py-3 font-black text-white">{t.actions.download}</button>
          {status && <p className="text-sm font-bold text-maroon">{status}</p>}
          {download && (
            <div className="rounded-sur bg-ivory p-4">
              <span className="text-sm font-bold text-muted">{t.forms.downloadNumber}</span>
              <strong className="block text-xl text-maroon">{download.downloadNumber}</strong>
              <a className="mt-4 inline-block rounded-sur bg-royal px-4 py-3 font-black text-white" href={download.downloadUrl} target="_blank" rel="noreferrer">
                {t.actions.download}
              </a>
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
